import { render, staticRenderFns } from "./MortgageApplicationsChoiceWrapper.vue?vue&type=template&id=0a107372&scoped=true&"
import script from "./MortgageApplicationsChoiceWrapper.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationsChoiceWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationsChoiceWrapper.vue?vue&type=style&index=0&id=0a107372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a107372",
  null
  
)

export default component.exports